import React, { useState, useEffect } from 'react';
import { IGetCategoriesShort, IGetCategoriesShortResponse } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getCategoriesShortInfoV2 } from 'backend/categories';
import FormSelect from 'components/Select/FormSelect';
import style from './AdditionalDishCategorySelect.module.scss';

interface IProps {
	setAdditionalDishCategory: (value: Nullable<string>) => void;
	IDsSelectedRestaurant: string[];
}

export const AdditionalDishCategorySelect: React.FC<IProps> = React.memo(
	({ setAdditionalDishCategory, IDsSelectedRestaurant }) => {
		const [isFirstRender, setIsFirstRender] = useState(true);
		const { response, loading, refetch, responseError } = useFetchData<
			IGetCategoriesShortResponse,
			IGetCategoriesShort
		>(IDsSelectedRestaurant.length ? getCategoriesShortInfoV2 : null, {
			restaurantIds: IDsSelectedRestaurant,
			type: 'AdditionalIngredients',
		});

		useEffect(() => {
			if (isFirstRender) {
				setIsFirstRender(false);
			} else {
				refetch();
			}
		}, [IDsSelectedRestaurant]);

		return (
			<FormSelect
				name="selectedAdditionalDishCategory"
				label="categoryLabel"
				formItemClassName={style.container}
				options={response?.data.categories}
				fetchError={responseError}
				loading={loading}
				onRefetch={refetch}
				disabled={!IDsSelectedRestaurant.length || loading}
				onChange={setAdditionalDishCategory}
				onMouseDown={(e) => e.stopPropagation()}
				onClick={(e) => e.stopPropagation()}
			/>
		);
	},
);
